import React, { useState, useEffect } from "react";
import { Drawer, IconButton, List } from "@material-ui/core";
import CategoryServices from "../../services/CategoryServices";

import {
  NotificationsNone as NotificationsIcon,
  Chat as Chat,
  FormatSize as TypographyIcon,
  UndoTwoTone as UndoTwoTone,
  HotTub as HotTub,
  Event as Event,
  Ballot as Ballot,
  OndemandVideo as OndemandVideo,
  ImageRounded as ImageRounded,
  SupervisedUserCircle as SupervisedUserCircle,
  ArtTrack as ArtTrack,
  FilterNone as UIElementsIcon,
  BorderAll as TableIcon,
  QuestionAnswer as SupportIcon,
  LibraryBooks as LibraryIcon,
  HelpOutline as FAQIcon,
  ArrowBack as ArrowBackIcon,
  SvgIconComponent as SvgIconComponent,
  CalendarToday as CalendarToday,
  AccessAlarmSharp as AccessAlarmSharp,
  Create as Create,
  LocationCity as LocationCity,
  HowToVoteSharp ,
  HistorySharp,
  OpenInNew,
  EvStation,
  LibraryMusicOutlined,
} from "@material-ui/icons";
import { useTheme } from "@material-ui/styles";
import { withRouter } from "react-router-dom";
import classNames from "classnames";
// styles
import useStyles from "./styles";
// components
import SidebarLink from "./components/SidebarLink/SidebarLink";
import Dot from "./components/Dot";
// context
import {
  useLayoutState,
  useLayoutDispatch,
  toggleSidebar,
} from "../../context/LayoutContext";

let structure = [
  
  
];

let batches = [
  
  {
    id: 1,
    label: "Batches",
    link: "/app/coaching",
    icon: <HotTub />,
  },
  // {
  //   id: 2,
  //   label: "Booking Reports",
  //   link: "/app/bookingreport",
  //   icon: <HowToVoteSharp />,
  // },
  // {
  //   id: 3,
  //   label: "Reports",
  //   link: "/app/report",
  //   icon: <SupervisedUserCircle />,
  // },
];

const userDetails = JSON.parse(localStorage.getItem("userDetail"));

if(userDetails && userDetails.registrationType === 'coaching'){
  structure = batches;
}else if(userDetails && userDetails.registrationType === 'park'){
  structure = [
   
    {
      id: 1,
      label: "Park",
      link: "/app/park",
      icon: <HotTub />,
    },
     {
      id: 1,
      label: "Bank Details",
      link: "/app/bankdetails",
      icon: <ImageRounded />,
    },
    // {
    //   id: 1,
    //   label: "Event",
    //   link: "/app/event",
    //   icon: <Event />,
    // },
    {
      id: 1,
      label: "User",
      link: "/app/user",
      icon: <UndoTwoTone />,
    },
    // {
    //   id: 2,
    //   label: "Detailed Report",
    //   link: "/app/bookingreport",
    //   icon: <HowToVoteSharp />,
    // },
    {
      id: 3,
      label: "Reports",
      link: "/app/report",
      icon: <SupervisedUserCircle />,
    },
    {
      id: 4,
      label: "Search",
      link: "/app/searchreports",
      icon: <OpenInNew />,
    },
       {
      id: 5,
      label: "Configuration",
      link: "/app/configuration",
      icon: <LibraryMusicOutlined />,
    },
    {
      id: 5,
      label: "Coupon",
      link: "/app/coupon",
      icon: <Chat />,
    },
    // {
    //   id: 6,
    //   label: "Advatagement",
    //   link: "/app/advatagement",
    //   icon: <LibraryMusicOutlined />,
    // },
  ]

}else if(userDetails && userDetails.registrationType === 'event'){
  structure = [
    {
      id: 1,
      label: "Event Details",
      link: "/app/event",
      icon: <Event />,
    },
    {
      id: 2,
      label: "Event",
      link: "/app/addevent",
      icon: <ImageRounded />,
    },
    {
      id: 3,
      label: "Bank Details",
      link: "/app/bankdetails",
      icon: <Ballot />,
    },
    {
      id: 4,
      label: "Reports",
      link: "/app/report",
      icon: <SupervisedUserCircle />,
    },
    {
      id: 5,
      label: "Search",
      link: "/app/searchreports",
      icon: <OpenInNew />,
    },
       {
      id: 6,
      label: "Configuration",
      link: "/app/configuration",
      icon: <LibraryMusicOutlined />,
    },
    {
      id: 7,
      label: "Coupon",
      link: "/app/coupon",
      icon: <Chat />,
    },
    {
      id: 8,
      label: "User Manual",
      link: "/app/usermanual",
      icon: <OndemandVideo />,
    },
  ]
}
else if(userDetails && userDetails.registrationType === 'doctor'){
  structure = [
  
   
   
    // {
    //   id: 5,
    //   label: "Specilization",
    //   link: "/app/specilization",
    //   icon: <DomainDisabledTwoTone />,
    // },
    // {
    //   id: 6,
    //   label: "Doctor",
    //   link: "/app/doctor",
    //   icon: <DockRounded />,
    // },
    {
      id: 7,
      label: "Clinic",
      link: "/app/clinic",
      icon: <HotTub />,
    },
    {
      id: 2,
      label: "Doctor Report",
      link: "/app/reportofdoctor",
      icon: <HowToVoteSharp />,
    },
  ]
}else if(userDetails && userDetails.registrationType === 'loan'){
  structure = [
  
    {
      id: 7,
      label: "Branch",
      link: "/app/branch",
      icon: <HotTub />,
    },
    // {
    //   id: 2,
    //   label: "Counter Detailes",
    //   link: "/app/counterdetailes",
    //   icon: <HowToVoteSharp />,
    // },
   
  ]
}else if(userDetails && userDetails.registrationType === 'counter'){
  structure = [
  
 
    {
      id: 2,
      label: "Counter Detailes",
      link: "/app/counterdetails",
      icon: <HowToVoteSharp />,
    },
  //  {
  //     id: 5,
  //     label: "Configuration",
  //     link: "/app/configuration",
  //     icon: <LibraryMusicOutlined />,
  //   },
  ]
}else if(userDetails && userDetails.registrationType === 'exbhition'){
  structure = [

 
    {
      id: 1,
      label: "Shows",
      link: "/app/exbhition",
      icon: <HowToVoteSharp />,
    },
    {
      id: 2,
      label: "Reports",
      link: "/app/showreports",
      icon: <LibraryMusicOutlined />,
    },
  ]
}else if(userDetails && userDetails.role === 'inspector'){
  structure = [
  
 
    {
      id: 1,
      label: "Reports",
      link: "/app/searchreports",
      icon: <SupervisedUserCircle />,
    },
  ]
}else  if(userDetails && userDetails.registrationType === 'admin'){
  structure = [
    // ...structure,...[
     {
        id: 1,
        label: "Advertisement",
        link: "/app/advatagement",
        icon: <LibraryMusicOutlined />,
      },
      {
        id: 2,
        label: "Reports",
        link: "/app/report",
        icon: <SupervisedUserCircle />,
      },
      {
        id: 3,
        label: "City",
        link: "/app/city",
        icon: <LocationCity />,
      },
      {
        id: 4,
        label: "Category",
        link: "/app/category",
        icon: <Ballot />,
      },
      {
        id: 5,
        label: "Events",
        link: "/app/adminevent",
        icon: <Event />,
      },

  // ]
  ]
    }

function Sidebar({ location }) {
  var classes = useStyles();
  var theme = useTheme();

  // global
  var { isSidebarOpened } = useLayoutState();
  var layoutDispatch = useLayoutDispatch();

  // local
  var [isPermanent, setPermanent] = useState(true);

  useEffect(function() {
    window.addEventListener("resize", handleWindowWidthChange);
    handleWindowWidthChange();
    return function cleanup() {
      window.removeEventListener("resize", handleWindowWidthChange);
    };
  });

  return (
    <Drawer
      variant={isPermanent ? "permanent" : "temporary"}
      className={classNames(classes.drawer, {
        [classes.drawerOpen]: isSidebarOpened,
        [classes.drawerClose]: !isSidebarOpened,
      })}
      classes={{
        paper: classNames({
          [classes.drawerOpen]: isSidebarOpened,
          [classes.drawerClose]: !isSidebarOpened,
        }),
      }}
      open={isSidebarOpened}
    >
      <div className={classes.toolbar} />
      <div className={classes.mobileBackButton}>
        <IconButton onClick={() => toggleSidebar(layoutDispatch)}>
          <ArrowBackIcon
            classes={{
              root: classNames(classes.headerIcon, classes.headerIconCollapse),
            }}
          />
        </IconButton>
      </div>
      <List className={classes.sidebarList}>
        {structure.map(link => (
          <SidebarLink
            key={link.id}
            location={location}
            isSidebarOpened={isSidebarOpened}
            {...link}
          />
        ))}
      </List>
    </Drawer>
  );
  // ##################################################################
  function handleWindowWidthChange() {
    var windowWidth = window.innerWidth;
    var breakpointWidth = theme.breakpoints.values.md;
    var isSmallScreen = windowWidth < breakpointWidth;
    if (isSmallScreen && isPermanent) {
      setPermanent(false);
    } else if (!isSmallScreen && !isPermanent) {
      setPermanent(true);
    }
  }
}

export default withRouter(Sidebar);
